export var ShakaBundle = /*#__PURE__*/ function(ShakaBundle) {
    ShakaBundle[ShakaBundle["ALL"] = 0] = "ALL";
    ShakaBundle[ShakaBundle["ALL_2015"] = 1] = "ALL_2015";
    ShakaBundle[ShakaBundle["DASH_TTML_ES5"] = 2] = "DASH_TTML_ES5";
    ShakaBundle[ShakaBundle["DASH_TTML_ES2015"] = 3] = "DASH_TTML_ES2015";
    ShakaBundle[ShakaBundle["DASH_VTT_ES5"] = 4] = "DASH_VTT_ES5";
    ShakaBundle[ShakaBundle["DASH_VTT_ES2015"] = 5] = "DASH_VTT_ES2015";
    ShakaBundle[ShakaBundle["HLS_ES5"] = 6] = "HLS_ES5";
    ShakaBundle[ShakaBundle["HLS_ES2015"] = 7] = "HLS_ES2015";
    ShakaBundle[ShakaBundle["DEBUG"] = 8] = "DEBUG";
    ShakaBundle[ShakaBundle["UNCOMPILED"] = 9] = "UNCOMPILED";
    return ShakaBundle;
}({});
export var ShakaRequestType = /*#__PURE__*/ function(ShakaRequestType) {
    ShakaRequestType[ShakaRequestType["MANIFEST"] = 0] = "MANIFEST";
    ShakaRequestType[ShakaRequestType["SEGMENT"] = 1] = "SEGMENT";
    ShakaRequestType[ShakaRequestType["DRM"] = 2] = "DRM";
    return ShakaRequestType;
}({});
export var ShakaPlayerEventType = /*#__PURE__*/ function(ShakaPlayerEventType) {
    ShakaPlayerEventType["loading"] = "loading";
    ShakaPlayerEventType["loaded"] = "loaded";
    ShakaPlayerEventType["buffering"] = "buffering";
    ShakaPlayerEventType["adaptation"] = "adaptation";
    ShakaPlayerEventType["mediaqualitychanged"] = "mediaqualitychanged";
    ShakaPlayerEventType["error"] = "error";
    ShakaPlayerEventType["trackschanged"] = "trackschanged";
    ShakaPlayerEventType["textchanged"] = "textchanged";
    ShakaPlayerEventType["emsg"] = "emsg";
    ShakaPlayerEventType["prft"] = "prft";
    ShakaPlayerEventType["variantchanged"] = "variantchanged";
    ShakaPlayerEventType["timelineregionadded"] = "timelineregionadded";
    ShakaPlayerEventType["largegap"] = "largegap";
    ShakaPlayerEventType["manifestparsed"] = "manifestparsed";
    ShakaPlayerEventType["segmentDownloaded"] = "segmentDownloaded";
    // to be removed when shaka v3 is phased out.
    ShakaPlayerEventType["segmentdownloaded"] = "segmentdownloaded";
    ShakaPlayerEventType["manifestupdated"] = "manifestupdated";
    ShakaPlayerEventType["audiotrackchanged"] = "audiotrackchanged";
    ShakaPlayerEventType["metadata"] = "metadata";
    ShakaPlayerEventType["downloadheadersreceived"] = "downloadheadersreceived";
    return ShakaPlayerEventType;
}({});
export var VideoElementEventType = /*#__PURE__*/ function(VideoElementEventType) {
    VideoElementEventType["timeupdate"] = "timeupdate";
    VideoElementEventType["durationchange"] = "durationchange";
    VideoElementEventType["pause"] = "pause";
    VideoElementEventType["playing"] = "playing";
    VideoElementEventType["ended"] = "ended";
    VideoElementEventType["seeking"] = "seeking";
    VideoElementEventType["seeked"] = "seeked";
    VideoElementEventType["canplaythrough"] = "canplaythrough";
    VideoElementEventType["play"] = "play";
    return VideoElementEventType;
}({});

//# sourceMappingURL=shaka.enums.js.map